import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { ConfigContext } from "../../../../../context/ConfigContext";
import { DealerAccountContext } from "../../../../../context/DealerAccountContext";
import { getHomeUrl } from "../../../../../utils/legacyHome";

interface ProcessSuccessProps {
  lineCount: number;
  fileCount?: number;
}

const ProcessSuccess = ({ lineCount, fileCount }: ProcessSuccessProps) => {
  const theme = useTheme();
  const { t } = useTranslation(["d2d", "common"]);
  const { JDPO_JAVA_URL, JDPOINT_URL, ENABLE_REMOVE_DASHBOARD_TAB } =
    useContext(ConfigContext);
  const { dealerAccount } = useContext(DealerAccountContext);
  const homeUrl = getHomeUrl(
    JDPO_JAVA_URL,
    JDPOINT_URL,
    dealerAccount?.id || "",
    ENABLE_REMOVE_DASHBOARD_TAB
  );

  return (
    <div
      data-testid="process-success-confirmation"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "8.75rem",
        marginBottom: "15.375rem",
      }}
    >
      <CheckCircleIcon
        data-testid="process-success-confirmation-icon"
        sx={{
          color: theme.tokens.FuelColorAlertSuccessIcon,
          width: theme.tokens.FuelFontSize5xl,
          height: theme.tokens.FuelFontSize5xl,
          marginBottom: theme.tokens.FuelSpacing4,
        }}
      />
      <Typography
        data-testid="process-success-confirmation-text1"
        sx={{
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          fontSize: theme.tokens.FuelFontSizeXl,
          lineHeight: theme.tokens.FuelLineHeightLg,
          marginBottom: theme.tokens.FuelSpacing6,
        }}
      >
        {fileCount
          ? t(
              fileCount === 1
                ? "d2d:myLocatorEntry.processChanges.success.fileToast"
                : "d2d:myLocatorEntry.processChanges.success.fileToast_plural",
              {
                count: fileCount,
              }
            )
          : t(
              lineCount === 1
                ? "d2d:myLocatorEntry.processChanges.success.toast"
                : "d2d:myLocatorEntry.processChanges.success.toast_plural",
              {
                count: lineCount,
              }
            )}
      </Typography>
      <Link data-testid="view-inventory-button" to="/my-locator-inventory">
        <Button
          variant="primary"
          sx={{
            width: "200px",
            padding: "12px 24px",
            marginBottom: theme.tokens.FuelLineHeightSm,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.tokens.FuelFontSizeMd,
              fontWeight: theme.tokens.FuelFontWeightSemibold,
              lineHeight: theme.tokens.FuelLineHeightMd,
            }}
          >
            {t("d2d:button.viewInventory")}
          </Typography>
        </Button>
      </Link>
      <Link
        data-testid="process-success-returnHome-text"
        aria-label="home-link"
        to={homeUrl}
      >
        <Button variant="text">
          <Typography
            sx={{
              fontWeight: theme.tokens.FuelFontWeightSemibold,
              fontSize: theme.tokens.FuelFontSizeSm,
              lineHeight: theme.tokens.FuelLineHeightMd,
            }}
          >
            {t("common:table.returnHome")}
          </Typography>
        </Button>
      </Link>
    </div>
  );
};

export default ProcessSuccess;
